export default __webpack_public_path__ + "static/media/white-add-edit-data-icon.2599d050.svg";